import { Text } from "@mantine/core"
import { NoAnswer } from "./NoAnswer"
import type { IAnswerProps } from "./types"

export function AnswerSelect({ answer, choices, question }: IAnswerProps & { choices?: string[] }) {
  if (answer?.value == null) return <NoAnswer />

  choices = choices ?? question.meta?.choices
  if (!choices) return null

  const value = choices[answer.value]

  return (
    <Text c="indigo" fz="lg">
      {value}
    </Text>
  )
}
